import { object, string } from "yup";

let newTaskFormSchema = object({
  website: string().required("Website cannot be empty."),
  title: string().required("Title cannot be empty."),
  description: string().required("Description cannot be empty."),
});

export default newTaskFormSchema;
